<template>
  <div class="Intoduction">
    <ComTitlte titleEn="INTRODUCTION" titleZh="协会简介"></ComTitlte>
    <div class="main clear">
      <div class="m_info">
        <div class="m_desc">
          <p>
            广州市化工行业协会成立于1999年4月，是由广州地区从事化学工业和化工相关产业的生产、经营、储存、设计、服务咨询等企业或事业单位自愿结成的地方性、非营利性的社会组织。
          </p>
          <p>
            协会宗旨是：在国家政策、法规赋予行业协会的行业标准、行业服务、行业自律、行业代表、行业协调的基本职能及职责范围内，充分发挥连结政府与企业的桥梁和纽带作用，为政府和企业服务，加强和改善行业管理，维护会员合法权益，促进广州化工行业经济发展。
          </p>
          <p>
            广州市化工行业协会成立以来，在行业性专业培训、行业竞赛、政策咨询和解读、高级研修班、跨地区交流学习、专业园区进驻服务、为政府提供可行性研究等方面做了大量工作。同时，在申请危险化学品经营许可证、运输许可证等方面开展相关政策技术培训服务。
          </p>
        </div>
      </div>
      <div class="m_img">
        <img src="../../../assets/img/company/a_img.png" alt="..." />
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "Intoduction",
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
.Intoduction {
  margin: 30px auto 0;
  background-color: #ffffff;
  border: solid 1px #e3e3e3;
  padding: 20px 30px 30px 30px;
  .main {
    padding: 20px 0 0 0;
    position: relative;
    .m_img {
      float: left;
      width: 482px;
      height: 326px;
      z-index: 2;
      margin: 20px 0 0 50px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .m_info {
      float: left;
      width: 580px;
      min-height: 326px;
      box-sizing: border-box;
      .i_title {
        display: flex;
        align-items: center;
        .t_icon {
          width: 13px;
          height: 16px;
        }
        .t_zh {
          font-size: 18px;
          line-height: 30px;
          color: #333;
          margin-left: 8px;
        }
        .t_en {
          font-size: 18px;
          line-height: 30px;
          color: #bcbcbc;
          margin-left: 6px;
        }
      }
      .m_desc {
        padding: 20px 0;
        p {
          font-size: 16px;
          text-indent: 32px;
          line-height: 30px;
          text-align: justify;
          color: #666;
        }
      }
    }
  }
}
</style>
